{
    "TargetreportformatLabel": "Target Report Format:",
    "TargetreportformatPdfOptionLabel": "PDF Document",
    "TargetreportformatRtfOptionLabel": "RTF Document",
    "TargetreportformatCsvOptionLabel": "CSV Export",
    "TargetreportformatXlsOptionLabel": "XLS Export",
    "UselanguageLabel": "Use Language:",
    "UselanguageEnusOptionLabel": "English (United States)",
    "UselanguageEngbOptionLabel": "English (United Kingdom)",
    "PapersizeLabel": "Paper Size:",
    "PapersizeA4OptionLabel": "A4 (210mm x 297mm)",
    "PapersizeLegalOptionLabel": "Legal (8½\" x 14\")",
    "PapersizeLetterOptionLabel": "Letter (8½\" x 11\")",
    "NAME": "Format",
    "Format_SectionHeader": "Format"
}